import * as React from "react";
import { TabContentsProps } from "./typings";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import { ExperienceTemplateRenderer } from "experience-template-renderer-react";
import { withStores } from "stores";

export const TabContents = withStores("context")(
  ({ blossomComponent, context, templateComponent }: TabContentsProps) => {
    if (blossomComponent) {
      return <BlossomComponents blossomComponent={blossomComponent} context={context} />;
    }

    /* istanbul ignore next */
    if (templateComponent?.children) {
      return <ExperienceTemplateRenderer templateComponents={templateComponent.children} />;
    }

    /* istanbul ignore next */
    return null;
  }
);

export default TabContents;
